module.exports = __webpack_public_path__ + "img/user2.60434761.png";